import pagePagination from './main.vue';

export default pagePagination;
